// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"service-header_headerWrapper__bnjtp","title":"service-header_title__Jysgv"};